import React from 'react';

interface HeaderProps {
  title: string;
  showBack?: boolean;
  onBack?: () => void;
  showMenu?: boolean;
  chatParticipant?: { profileImage?: string; vorname: string; nachname: string } | null;
  onChatParticipantClick?: () => void;
  showAddChat?: boolean;
  onAddChat?: () => void;
}

const CalendarIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
  </svg>
);

const BackIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
  </svg>
);

const MenuIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
  </svg>
);


const Header: React.FC<HeaderProps> = ({ title, showBack, onBack, showMenu = true, chatParticipant, onChatParticipantClick, showAddChat, onAddChat }) => {
   return (
     <header className="bg-white text-black border-b border-gray-300 sticky top-0 z-20">
       <div className="container mx-auto px-4 h-16 flex items-center justify-between max-w-sm md:max-w-2xl lg:max-w-4xl">
         <div className="flex items-center gap-3">
           {showBack ? (
             <button onClick={onBack} aria-label="Zurück" className="p-2 -ml-2">
               <BackIcon className="w-6 h-6" />
             </button>
           ) : (
             <CalendarIcon className="w-7 h-7" />
           )}
           {chatParticipant ? (
             <button
               type="button"
               onClick={onChatParticipantClick}
               disabled={!onChatParticipantClick}
               className="flex items-center gap-3 min-w-0 disabled:cursor-default"
             >
               {chatParticipant.profileImage ? (
                 <img src={chatParticipant.profileImage} alt={chatParticipant.vorname} className="w-9 h-9 rounded-full object-cover border border-gray-200" />
               ) : (
                 <div className="w-9 h-9 rounded-full bg-linear-to-br from-pink-400 to-purple-500 flex items-center justify-center text-white font-bold">
                   {chatParticipant.vorname.charAt(0)}{chatParticipant.nachname.charAt(0)}
                 </div>
               )}
               <span className="text-lg font-semibold truncate">{chatParticipant.vorname} {chatParticipant.nachname}</span>
             </button>
           ) : (
             <h1 className="text-xl md:text-2xl font-bold truncate">
               {title}
             </h1>
           )}
         </div>

         <div className="flex items-center gap-3">
           {showAddChat && (
             <button
               type="button"
               onClick={onAddChat}
               aria-label="Neuen Chat starten"
               className="w-8 h-8 rounded-full bg-pink-600 text-white flex items-center justify-center hover:bg-pink-700 transition-colors"
             >
               +
             </button>
           )}
           {showMenu && (
             <button
               aria-label="Menü"
               className="p-2 -mr-2"
               data-drawer-target="navigation-drawer"
               data-drawer-show="navigation-drawer"
               data-drawer-placement="right"
               aria-controls="navigation-drawer"
             >
               <MenuIcon className="w-6 h-6" />
             </button>
           )}
         </div>
       </div>
     </header>
   );
 };

 export default Header;
